<template>
    <div class="modal fade" id="confirmScopeEnableDisablePopUp" tabindex="-1" role="dialog" aria-labelledby="confirmScopeEnableDisablePopUp" aria-hidden="true" data-keyboard="false" data-backdrop="static">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content campaign-g-addedit">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLongTitle">{{delHeaderMsg}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click = "closePopUpAction">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <p>{{isDiffMsg}}</p>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal" @click = "closePopUpAction">No</button>
                    <button type="button" @click="deleteSelectedProducts" class="btn btn-primary" data-dismiss="modal">Yes</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:'ScopeEnableDisablePopUp',
    data() {
        return {

        }
    },
    props: {
		isDiffMsg:String,
		notDeleted : Boolean,
		delHeaderMsg: String
    },
    methods: {
        deleteSelectedProducts() {
			if(this.notDeleted){
				$('#confirmScopeEnableDisablePopUp').modal('hide')
			}else{
				this.$emit('deleteSelectedProducts')

			}
        },
		closePopUpAction(){
			this.$emit("closeActiveRuleModal")
		}
    },
}
</script>

<style lang="scss">

</style>
